import React, { useEffect, useState } from 'react';
import '@preline/stepper';
import { formatZuluTime } from '../../helpers/converter';

function Stepper({ stateHistory }) {
    const [stateHistoryLength, setStateHistoryLength] = useState(0);
    const [lastStatus, setLastStatus] = useState(null);

    useEffect(() => {
        if (stateHistory && stateHistory.length > 0) {
            setStateHistoryLength(stateHistory.length);
            setLastStatus(stateHistory[stateHistory.length - 1].newStatus);
        }
    }, [stateHistory]);

    // Bu fonksiyon, adımın son adım olup olmadığına ve durumuna göre arkaplan rengini belirler
    const getBackgroundColor = (status, index) => {
        const isLastStep = index === stateHistoryLength - 1;
        if (status === 10 && isLastStep) {
            return 'bg-[#FDE047]'; // Son adım ve durumu 10 ise sarı
        } else if (status === 10) {
            return 'bg-[#9DE7BE]'; // Son adım değilse ve durumu 10 ise yeşil
        } else if (status === 3) {
            return 'bg-[#F87171]'; // Durumu 3 ise kırmızı
        } else if (status === 2 || status === 4) {
            return 'bg-[#9DE7BE]'; // Durumu 2 veya 4 ise yeşil
        } else {
            return 'bg-[#9DE7BE]'; // Diğer durumlar için gri
        }
    };

    return (
        <div data-hs-stepper className='mt-4 mb-4'>
            <ul className="relative flex flex-col md:flex-row gap-2 gap-x-2">
                {stateHistory.map((step, index) => (
                    <>
                        {step.newStatus !== 1 ?
                            <li key={index} className="flex items-center gap-x-2 shrink basis-0 flex-1 group">
                                <div className="min-w-7 min-h-7 inline-flex justify-center items-center text-xs align-middle">
                                    <span className={`${getBackgroundColor(step.newStatus, index)} p-2 size-7 flex justify-center items-center flex-shrink-0 border border-gray-200 font-medium text-gray-800 rounded-full dark:bg-slate-900 dark:border-gray-700 dark:text-white`}>
                                        <i className={`fa ${step.newStatus === 10 ? 'fa-hourglass-start' : step.newStatus === 3 ? 'fa-times' : 'fa-arrow-right'}`}></i>
                                    </span>
                                    <span className="ms-2 block text-sm font-medium text-gray-800 dark:text-white">
                                        {step.newStatus === 0 ?
                                            `Ödeme bekleniyor` :
                                            step.newStatus === 11 ?
                                                `Tıbbi sekreterya` :
                                                step.newStatus === 10 ?
                                                    `Doktor onayı bekleniyor` :
                                                    step.newStatus === 3 ?
                                                        `Doktor tarafından reddedildi` :
                                                        step.newStatus === 2 || step.newStatus === 4 ?
                                                            `Raporlanıyor` :
                                                            step.newStatus === 6 ?
                                                                `Tamamlandı`
                                                                : null
                                        }
                                        
                                        <br />
                                        <small>{step.createdAt ? formatZuluTime(step.createdAt) : ''}</small>
                                    </span>
                                </div>
                                {index + 1 < stateHistoryLength &&
                                    <div className="w-full h-px flex-1 bg-gray-200 dark:bg-gray-700"></div>
                                }
                            </li>
                            : null}
                    </>
                ))}
            </ul>
        </div>
    );
}

export default Stepper;
